import { useTranslation } from 'react-i18next';
import { getPortalName, usePortalName } from './usePortalName';
import i18next, { TFunction } from 'i18next';

export const useCommonTranslation = (): Function => {
  const portalName = usePortalName();
  const { t } = useTranslation(portalName || 'common');
  return (
    key: string | TemplateStringsArray | (string | TemplateStringsArray)[],
    params?: any,
  ) => t(key, params) || '';
};

// Use where React hooks are not available.
export const useDefaultTranslation = ((key: string) => {
  const ns = getPortalName() || 'common';
  return i18next.t(key, { ns }) || '';
}) as TFunction<'common'>;
